(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1208],{

/***/ 53219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowLeft; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
];
const ArrowLeft = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("arrow-left", __iconNode);


//# sourceMappingURL=arrow-left.js.map


/***/ }),

/***/ 13742:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Check; }
/* harmony export */ });
/* unused harmony export __iconNode */
/* harmony import */ var _createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91373);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]];
const Check = (0,_createLucideIcon_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("check", __iconNode);


//# sourceMappingURL=check.js.map


/***/ }),

/***/ 43200:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/ai-verification",
      function () {
        return __webpack_require__(17803);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _v3_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56475);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const CLMHero2 = (param)=>{
    let { CLMHeroData  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "max-w-screen-xl mx-auto text-black relative mb-5 md:mb-24 md:mt-16 md:mt-0",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative z-10 flex flex-col items-center justify-start md:gap-6 px-4 md:px-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-col items-center justify-center gap-6 md:gap-7 mt-8 w-full ",
                        children: [
                            CLMHeroData.title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl text-violet-600 uppercase",
                                children: CLMHeroData.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-5xl leading-[48px] md:text-[72px] md:leading-[72px] text-center max-w-full md:w-[95%] xl:w-[90%] font-semibold",
                                children: CLMHeroData.heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg font-medium text-gray-800 md:text-2xl text-center md:w-[80%]",
                                children: CLMHeroData.description
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_v3_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .CLMButtonPrimary */ .IS, {
                                buttonText: CLMHeroData.btnText,
                                buttonUrl: CLMHeroData.btnUrl
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "max-w-screen-xl md:mx-8 mx-auto pt-8",
                        children: [
                            CLMHeroData.video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                                src: CLMHeroData.video,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl",
                                autoPlay: true,
                                loop: true,
                                muted: true
                            }),
                            CLMHeroData.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: CLMHeroData.image,
                                alt: "ai-agent-builder",
                                width: 1216,
                                height: 500,
                                className: "rounded-xl"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CLMHero2);


/***/ }),

/***/ 24062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13742);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





const EqualDivisionSection = (param)=>{
    let { title , heading , description , checks , image ="" , video ="" , bgColor , imageRight =true , opinion , imageRounded =true , leftDivStyle =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(bgColor, " py-7 md:py-32 transition-all duration-700"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-xl md:px-8 px-6 mx-auto grid md:grid-cols-2 gap-6 md:gap-12 xl:gap-20 items-start ".concat(leftDivStyle),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "".concat(imageRight ? "md:order-1" : "md:order-2", " order-1"),
                    children: [
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "uppercase text-purple-900 mb-2 text-xs md:text-base font-semibold",
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "", " text-[28px]  md:text-4xl xl:text-5xl font-semibold text-start ").concat(heading && "mb-6"),
                            children: heading
                        }),
                        description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-900", " mb-6  md:text-2xl font-semibold md:font-normal font-medium text-left"),
                            children: description
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            className: "space-y-4 ".concat(bgColor == "bg-dark" ? "text-white" : "text-gray-800", " text-lg md:leading-none xl:leading-relaxed"),
                            children: checks.map((check, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                    className: "flex items-start text-start",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            className: "w-5 h-5 text-gray-800 bg-purple-200 rounded-full p-1 mr-2 mt-1 shrink-0"
                                        }),
                                        check
                                    ]
                                }, idx))
                        }),
                        opinion && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "".concat(bgColor == "bg-dark" ? "text-white" : "text-black", " mb-6  md:text-base w-[70%] pl-4 font-semibold font-medium mt-10 text-start hidden md:block"),
                            children: [
                                opinion,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "-BoloSign User"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "bg-color  rounded-2xl relative  ".concat(imageRight ? "order-2" : "order-1"),
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: image,
                            alt: "Contract Creation",
                            width: 500,
                            height: 500,
                            className: "w-full ".concat(imageRounded ? "rounded-2xl" : "")
                        }),
                        video && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("video", {
                            src: video,
                            autoPlay: true,
                            muted: true,
                            loop: true,
                            className: "w-full h-full object-cover rounded-2xl"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EqualDivisionSection);


/***/ }),

/***/ 74791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7314);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31012);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function FaqItem(param) {
    let { question , answer , isOpen , onToggle  } = param;
    const contentRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [height, setHeight] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isOpen && contentRef.current) {
            setHeight(contentRef.current.scrollHeight);
        } else {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        onClick: onToggle,
        className: "px-8 py-7 transition-all duration-300",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "flex justify-between items-center w-full text-left gap-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-[20px] leading-[26px] font-semibold",
                        children: question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-purple-600 text-xl border-2 border-purple-600 rounded-full p-1",
                        children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            size: 20
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            size: 20
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: contentRef,
                style: {
                    maxHeight: "".concat(height, "px"),
                    overflow: "hidden",
                    transition: "max-height 0.3s ease, opacity 0.3s ease",
                    opacity: isOpen ? 1 : 0
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: answer
                    },
                    className: "mt-6 text-gray-700 text-[18px] leading-[26px] font-medium"
                })
            })
        ]
    });
}
function FaqList(param) {
    let { faqs  } = param;
    const [openIndex, setOpenIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: faqs.map((faq, index)=>{
            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: " bg-white rounded-2xl border border-surface-dark mt-4 text-left w-full mx-auto ".concat(openIndex === index ? "" : "hover:bg-surface-dark", " transition-all  duration-300"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqItem, {
                    question: faq === null || faq === void 0 ? void 0 : faq.question,
                    answer: faq === null || faq === void 0 ? void 0 : faq.answer,
                    isOpen: openIndex === index,
                    onToggle: ()=>setOpenIndex(openIndex === index ? null : index)
                }, index)
            }, index);
        })
    });
}
const FAQ2 = (param)=>{
    let { faqData , heading , description  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "md:w-[920px] max-w-full mx-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: "text-4xl md:text-5xl font-semibold leading-snug mb-8",
                children: heading
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-[18px] leading-[22px] font-medium md:w-[80%] mx-auto w-full mt-2 mb-12",
                children: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqList, {
                faqs: faqData
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQ2);


/***/ }),

/***/ 73768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13114);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17568);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53219);
/* harmony import */ var lucide_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(82701);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);






const testimonials = [
    {
        companyLogo: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-eye-care-1.png"),
        quote: "BoloSign helped us streamline our caregiver agreements. What used to take hours is now done in minutes, and everything is HIPAA-compliant.",
        avatar: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-rachel.png"),
        name: "Rachel Monroe",
        title: "Director of Operations at Eye Care"
    },
    {
        companyLogo: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-bena-vest-1.png"),
        quote: "We handle hundreds of client policies across health and retirement. BoloSign lets us streamline compliance paperwork and maintain a clear signing history for every client interaction.",
        avatar: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-jonathan.png"),
        name: "Jonathan Ellis",
        title: "Head of Compliance at BenaVest"
    },
    {
        companyLogo: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-overstock-1.png"),
        quote: "We've scaled to 30+ locations. Without BoloSign, keeping track of sales agreements, warranty policies, and franchise contracts would've been a nightmare.",
        avatar: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/clm/clm/testimonial-slider-greg.png"),
        name: "Greg Thomas",
        title: "VP of Retail Operations at Overstock Furniture & Mattress"
    }
];
const TestimonialSlider = ()=>{
    const transition = {
        duration: 0.5,
        ease: "easeInOut"
    };
    const [currentIndex, setCurrentIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const variants = {
        enter: {
            y: 20,
            opacity: 0
        },
        center: {
            y: 0,
            opacity: 1
        },
        exit: {
            y: 25,
            opacity: 0
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "px-8 max-w-screen-xl xl:mx-auto",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: "bg-cream rounded-3xl py-4 mx-4 md:mx-10 px-4 md:py-20 md:px-32 xl:px-48 my-12 shadow-sm transition-all duration-400 max-w-screen-xl xl:mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_4__/* .AnimatePresence */ .M, {
                    mode: "wait",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(framer_motion__WEBPACK_IMPORTED_MODULE_5__/* .motion.div */ .E.div, {
                        initial: "enter",
                        animate: "center",
                        exit: "exit",
                        variants: variants,
                        transition: transition,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    // src={`${BASE_ASSETS_URL}/v2/clm/clm/circularise.svg")}
                                    src: testimonials[currentIndex].companyLogo,
                                    alt: "Company Logo",
                                    width: 200,
                                    height: 200
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-2xl text-gray-900 mb-6",
                                children: [
                                    "“",
                                    testimonials[currentIndex].quote,
                                    "”"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center justify-left gap-4",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                        src: testimonials[currentIndex].avatar,
                                        alt: testimonials[currentIndex].name,
                                        width: 50,
                                        height: 50,
                                        className: "rounded-lg object-cover"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "text-sm",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "font-semibold text-gray-900",
                                                children: testimonials[currentIndex].name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-gray-600",
                                                children: testimonials[currentIndex].title
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, currentIndex)
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex justify-end mt-6 gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: ()=>setCurrentIndex((i)=>i - 1),
                            disabled: currentIndex === 0,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                className: currentIndex === 0 ? "w-6 h-6 text-blue-200" : "w-6 h-6 text-blue-600"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            onClick: ()=>setCurrentIndex((i)=>i + 1),
                            disabled: currentIndex === testimonials.length - 1,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(lucide_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                className: currentIndex === testimonials.length - 1 ? "w-6 h-6 text-blue-200" : "w-6 h-6 text-blue-600"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TestimonialSlider);


/***/ }),

/***/ 17803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29937);
/* harmony import */ var components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24062);
/* harmony import */ var components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74791);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var components_CLM_TestimonialSliderSection__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73768);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43138);








const CLMHeroData = {
    // title: "Reporting",
    heading: "Review contracts in minutes, not hours",
    description: "Let AI do your work 70% faster with greater accuracy",
    image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/ai-verification-hero.gif"),
    btnText: "Review a contract for free",
    btnUrl: "/clm/request-demo"
};
const aiVerificationFaqData = [
    {
        question: "What is AI Verification?",
        answer: "AI Verification is BoloSign’s intelligent layer built to verify signer identities during the document signing process. It ensures that the person signing is genuine by using facial comparison, behavior analysis, and secure data validation—all within seconds."
    },
    {
        question: "What can I do with AI Verification?",
        answer: "AI Verification allows you to:\n\n- Automatically detect mismatches between a signer's photo and ID\n- Flag potential identity issues before a document is signed\n- Apply specific verification checks based on document type\n- Share verification results securely with your internal teams\n- Maintain legal integrity and reduce fraudulent signing"
    },
    {
        question: "When can I use AI Verification?",
        answer: "You can use AI Verification every time a document is sent for signature. Whether it’s your own contract or one shared with a counterparty, the feature is ready to activate at the click of a button. It’s especially helpful for legal, HR, or financial teams that need reliable identity proof."
    },
    {
        question: "How does AI Verification work?",
        answer: "AI Verification works as a built-in workflow in BoloSign:\n\n- Signer receives the verification prompt before accessing the document\n- They’re asked to take a live selfie or upload an ID\n- Our AI checks for facial match, liveness, and anomalies\n- If all checks are passed, the signing continues\n- Failed attempts are flagged and reported with reasoning\n\nNo extra software is needed—it works right inside the browser."
    },
    {
        question: "What AI model does BoloSign use for verification?",
        answer: "BoloSign uses a combination of leading LLMs and computer vision models tailored for secure identity validation. These models are chosen dynamically to ensure the best result for the verification task, without relying solely on a single provider like OpenAI. All models are used within a compliant, secure cloud environment."
    },
    {
        question: "How is data stored and handled in AI Verification?",
        answer: "We prioritize privacy and data protection. Verification data is encrypted in transit and at rest, processed securely, and stored in compliance with major privacy laws such as GDPR. We never share or repurpose user biometric data."
    }
];
// const testimonials = [
//   {
//     companyLogo: "https://via.placeholder.com/100x30?text=Circularise",
//     quote:
//       "The metadata management at SpotDraft is really amazing... my team can access key terms any time, without needing me to provide that .",
//     avatar: "https://randomuser.me/api/portraits/women/44.jpg",
//     name: "Arzu Hasanova",
//     title: "Legal Counsel at Circularise",
//   },
//   {
//     companyLogo: "https://via.placeholder.com/100x30?text=Fintract",
//     quote:
//       "SpotDraft transformed how we handle contracts. It’s efficient, intuitive, and has become an essential part of our workflow.",
//     avatar: "https://randomuser.me/api/portraits/men/32.jpg",
//     name: "John Miller",
//     title: "Head of Legal at Fintract",
//   },
// ];
// function TestimonialSlider({ testimonials, currentIndex, setCurrentIndex }) {
//   const transition = { duration: 0.5, ease: "easeInOut" };
//   const variants = {
//     enter: { y: 20, opacity: 0 },
//     center: { y: 0, opacity: 1 },
//     exit: { y: 25, opacity: 0 },
//   };
//   return (
//     <div className="px-8  max-w-screen-xl xl:mx-auto">
//       <section className="bg-blue-50 rounded-3xl py-4 mx-4 md:mx-10 px-4 md:py-20 md:px-48 my-12 shadow-sm transition-all duration-400 max-w-screen-xl xl:mx-auto">
//         <AnimatePresence mode="wait">
//           <motion.div
//             key={currentIndex}
//             initial="enter"
//             animate="center"
//             exit="exit"
//             variants={variants}
//             transition={transition}
//           >
//             {/* Logo */}
//             <div className="mb-4">
//               <Image
//                 src={`${BASE_ASSETS_URL}/v2/clm/clm//circularise.svg")}
//                 alt="Company Logo"
//                 width={200}
//                 height={200}
//               />
//             </div>
//             {/* Quote */}
//             <p className="text-2xl text-gray-900 mb-6">
//               “{testimonials[currentIndex].quote}”
//             </p>
//             {/* Avatar + Name */}
//             <div className="flex items-center justify-left gap-4">
//               <Image
//                 src={testimonials[currentIndex].avatar}
//                 alt={testimonials[currentIndex].name}
//                 width={50}
//                 height={50}
//                 className="rounded-lg object-cover"
//               />
//               <div className="text-sm">
//                 <p className="font-semibold text-gray-900">
//                   {testimonials[currentIndex].name}
//                 </p>
//                 <p className="text-gray-600">
//                   {testimonials[currentIndex].title}
//                 </p>
//               </div>
//             </div>
//           </motion.div>
//         </AnimatePresence>
//         {/* Arrows */}
//         {/* when the button is disabled it should be dull in color */}
//         {/* when the button is enabled it should be bright in color */}
//         <div className="flex justify-end mt-6 gap-4">
//           <button
//             onClick={() => setCurrentIndex((i) => i - 1)}
//             disabled={currentIndex === 0}
//           >
//             <ArrowLeftIcon
//               className={
//                 currentIndex === 0
//                   ? "w-6 h-6 text-blue-200"
//                   : "w-6 h-6 text-blue-600"
//               }
//             />
//           </button>
//           <button
//             onClick={() => setCurrentIndex((i) => i + 1)}
//             disabled={currentIndex === testimonials.length - 1}
//           >
//             <ArrowRightIcon
//               className={
//                 currentIndex === testimonials.length - 1
//                   ? "w-6 h-6 text-blue-200"
//                   : "w-6 h-6 text-blue-600"
//               }
//             />
//           </button>
//         </div>
//       </section>
//     </div>
//   );
// }
const AIVerification = ()=>{
    const [currentIndex, setCurrentIndex] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(0);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "AI Verification | BoloSign CLM"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "AI Verification is BoloSign’s intelligent layer built to verify signer identities during the document signing process. It ensures that the person signing is genuine by using facial comparison, behavior analysis, and secure data validation—all within seconds."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "AI Verification, Contract Management, eSignatures, Identity Verification, BoloSign CLM, Secure Signing, AI-powered Contracts"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/clm/ai-verification/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_CLMHero2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                CLMHeroData: CLMHeroData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center bg-cream py-24",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "text-4xl md:text-5xl mb-6",
                        children: "Smarter, faster & easier contract reviews"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl lg:w-[70%] xl:w-[50%] mx-auto px-6 md:px-0",
                        children: "AI Verification lets you create and run contract review playbooks in seconds, using AI trained by top legal experts for unmatched accuracy and efficiency."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title=""
                heading: "Speed up contract reviews with AI-powered custom playbooks",
                description: "Turn your legal expertise into contract review workflows. With simple inputs, you can build tailored playbooks to identify risks, track compliance, and streamline your review process in seconds.",
                checks: [
                    "Link each guideline to its source for clarity and context.",
                    "Know exactly why a clause passes or fails compliance checks.",
                    "Easily update and refine your playbooks as standards evolve."
                ],
                image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/ai-verification-agreement.gif"),
                bgColor: "",
                imageRight: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title=""
                heading: "Improve your contracts with precise edits & Insights",
                description: "Leverage insights shaped by the experience of hundreds of legal professionals to refine and strengthen your agreements.",
                checks: [
                    "Receive tailored language suggestions to reflect your intent in the contract.",
                    "Add contextual comments to clarify changes for collaborators or reviewers.",
                    "Edit contracts with visible track changes for transparency and review."
                ],
                image: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/clm/ai-verification-improve-contract.gif"),
                bgColor: "bg-dark",
                imageRight: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title=""
                heading: "Instantly create review playbooks from your templates",
                description: "Turn any contract template into a smart review playbook within minutes using AI.",
                checks: [
                    'Upload your template and hit "Generate with AI".',
                    "Instantly receive a playbook with auto-drafted rules and review guidelines.",
                    "Run any contract through your playbook with just a click."
                ],
                // image={`${BASE_ASSETS_URL}/v2/clm/clm//ai-verification-instantly.gif`}
                video: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/videos/ai-verification-instantly.mp4"),
                bgColor: "",
                imageRight: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_TestimonialSliderSection__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_EqualDivisionSection__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                // title=""
                heading: "Let your team handle the initial contract review",
                description: "Empower cross-functional teams to perform the first-level contract checks by sharing easy-to-access contract guides. This helps spot common issues early, without needing to send every document to Legal right away.",
                checks: [
                    "Instantly share review guides via a link – no login required.",
                    "Skip the need for Microsoft Word or heavy software.",
                    "Access and review on both mobile and desktop with ease."
                ],
                // image={`${BASE_ASSETS_URL}/v2/clm/clm//ai-verification-new-msg.gif")}
                video: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_7__.BASE_ASSETS_URL, "/v2/clm/videos/ai-verification-new-msg.mp4"),
                bgColor: "",
                imageRight: false
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: "bg-cream text-black py-16 md:px-10 px-4 xl:px-20 text-center md:pt-24 pt-12 ",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CLM_FAQ2__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    faqData: aiVerificationFaqData,
                    heading: "AI Verification FAQs"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (AIVerification);


/***/ }),

/***/ 13114:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ AnimatePresence; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/LayoutGroupContext.mjs
var LayoutGroupContext = __webpack_require__(25364);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(96681);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-isomorphic-effect.mjs
var use_isomorphic_effect = __webpack_require__(58868);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/PresenceContext.mjs
var PresenceContext = __webpack_require__(240);
// EXTERNAL MODULE: ./node_modules/motion-dom/dist/es/utils/is-html-element.mjs
var is_html_element = __webpack_require__(93243);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
var MotionConfigContext = __webpack_require__(16014);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/PopChild.mjs
"use client";






/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */
class PopChildMeasure extends react.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if (element && prevProps.isPresent && !this.props.isPresent) {
            const parent = element.offsetParent;
            const parentWidth = (0,is_html_element/* isHTMLElement */.R)(parent)
                ? parent.offsetWidth || 0
                : 0;
            const size = this.props.sizeRef.current;
            size.height = element.offsetHeight || 0;
            size.width = element.offsetWidth || 0;
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */
    componentDidUpdate() { }
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent, anchorX }) {
    const id = (0,react.useId)();
    const ref = (0,react.useRef)(null);
    const size = (0,react.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
    });
    const { nonce } = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */
    (0,react.useInsertionEffect)(() => {
        const { width, height, top, left, right } = size.current;
        if (isPresent || !ref.current || !width || !height)
            return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce)
            style.nonce = nonce;
        document.head.appendChild(style);
        if (style.sheet) {
            style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            top: ${top}px !important;
          }
        `);
        }
        return () => {
            if (document.head.contains(style)) {
                document.head.removeChild(style);
            }
        };
    }, [isPresent]);
    return ((0,jsx_runtime.jsx)(PopChildMeasure, { isPresent: isPresent, childRef: ref, sizeRef: size, children: react.cloneElement(children, { ref }) }));
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/PresenceChild.mjs
"use client";







const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, anchorX, }) => {
    const presenceChildren = (0,use_constant/* useConstant */.h)(newChildrenMap);
    const id = (0,react.useId)();
    let isReusedContext = true;
    let context = (0,react.useMemo)(() => {
        isReusedContext = false;
        return {
            id,
            initial,
            isPresent,
            custom,
            onExitComplete: (childId) => {
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()) {
                    if (!isComplete)
                        return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId) => {
                presenceChildren.set(childId, false);
                return () => presenceChildren.delete(childId);
            },
        };
    }, [isPresent, presenceChildren, onExitComplete]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    if (presenceAffectsLayout && isReusedContext) {
        context = { ...context };
    }
    (0,react.useMemo)(() => {
        presenceChildren.forEach((_, key) => presenceChildren.set(key, false));
    }, [isPresent]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */
    react.useEffect(() => {
        !isPresent &&
            !presenceChildren.size &&
            onExitComplete &&
            onExitComplete();
    }, [isPresent]);
    if (mode === "popLayout") {
        children = ((0,jsx_runtime.jsx)(PopChild, { isPresent: isPresent, anchorX: anchorX, children: children }));
    }
    return ((0,jsx_runtime.jsx)(PresenceContext/* PresenceContext.Provider */.O.Provider, { value: context, children: children }));
};
function newChildrenMap() {
    return new Map();
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.mjs
var use_presence = __webpack_require__(15947);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/utils.mjs


const getChildKey = (child) => child.key || "";
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    react.Children.forEach(children, (child) => {
        if ((0,react.isValidElement)(child))
            filtered.push(child);
    });
    return filtered;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs
"use client";









/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */
const AnimatePresence = ({ children, custom, initial = true, onExitComplete, presenceAffectsLayout = true, mode = "sync", propagate = false, anchorX = "left", }) => {
    const [isParentPresent, safeToRemove] = (0,use_presence/* usePresence */.oO)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */
    const presentChildren = (0,react.useMemo)(() => onlyElements(children), [children]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */
    const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map(getChildKey);
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */
    const isInitialRender = (0,react.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */
    const pendingPresentChildren = (0,react.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */
    const exitComplete = (0,use_constant/* useConstant */.h)(() => new Map());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */
    const [diffedChildren, setDiffedChildren] = (0,react.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0,react.useState)(presentChildren);
    (0,use_isomorphic_effect/* useIsomorphicLayoutEffect */.L)(() => {
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */
        for (let i = 0; i < renderedChildren.length; i++) {
            const key = getChildKey(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) {
                    exitComplete.set(key, false);
                }
            }
            else {
                exitComplete.delete(key);
            }
        }
    }, [renderedChildren, presentKeys.length, presentKeys.join("-")]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [...presentChildren];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */
        for (let i = 0; i < renderedChildren.length; i++) {
            const child = renderedChildren[i];
            const key = getChildKey(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */
        if (mode === "wait" && exitingChildren.length) {
            nextChildren = exitingChildren;
        }
        setRenderedChildren(onlyElements(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */
        return null;
    }
    if (false) {}
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */
    const { forceRender } = (0,react.useContext)(LayoutGroupContext/* LayoutGroupContext */.p);
    return ((0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children: renderedChildren.map((child) => {
            const key = getChildKey(child);
            const isPresent = propagate && !isParentPresent
                ? false
                : presentChildren === renderedChildren ||
                    presentKeys.includes(key);
            const onExit = () => {
                if (exitComplete.has(key)) {
                    exitComplete.set(key, true);
                }
                else {
                    return;
                }
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete) => {
                    if (!isExitComplete)
                        isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return ((0,jsx_runtime.jsx)(PresenceChild, { isPresent: isPresent, initial: !isInitialRender.current || initial
                    ? undefined
                    : false, custom: custom, presenceAffectsLayout: presenceAffectsLayout, mode: mode, onExitComplete: isPresent ? undefined : onExit, anchorX: anchorX, children: child }, key));
        }) }));
};




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8041,9774,2888,179], function() { return __webpack_exec__(43200); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);